<iframe #iframe *ngIf="safeIframeSrcUrl" [src]="safeIframeSrcUrl"></iframe>